// Next
import Image from 'next/image';

// Contentful
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { RENDER_DOCUMENT_OPTIONS, imageLoader } from '../../helpers/contentful';

// Components
import Author from '../Author/Author';

const ExplainerBlock = (props) => {
  const { quote, author, title, content, contentAfterQuote, infographic } = props;

  return (
    <div className="ExplainerBlock">
      <div className="ExplainerBlock-inner">
        <div className="ExplainerBlock-wrapper">
          {content && title && (
            <div className="ExplainerBlock-content">
              <div className="ExplainerBlock-contentWrap">
                {title && (
                  <h2 className="ExplainerBlock-title">{documentToReactComponents(title, RENDER_DOCUMENT_OPTIONS)}</h2>
                )}
                <div className="ExplainerBlock-copy">
                  {content && documentToReactComponents(content, RENDER_DOCUMENT_OPTIONS)}
                  {quote && (
                    <div className="ExplainerBlock-quote">
                      <div className="ExplainerBlock-quoteText">“{quote}”</div>
                      <Author {...author} modifier="Author--explainerBlock" />
                    </div>
                  )}
                  {contentAfterQuote && documentToReactComponents(contentAfterQuote, RENDER_DOCUMENT_OPTIONS)}
                </div>
              </div>
            </div>
          )}
          {infographic && (
            <div className="ExplainerBlock-infographic">
              <div className="ExplainerBlock-infographicMobile">
                <Image
                  quality="100"
                  lazyBoundary="500px"
                  loader={imageLoader}
                  alt={infographic.mobile.alt}
                  src={`https:${infographic.mobile.src}`}
                  height={infographic.mobile.height}
                  width={infographic.mobile.width}
                />
              </div>
              <div className="ExplainerBlock-infographicDesktop">
                <Image
                  quality="100"
                  lazyBoundary="500px"
                  loader={imageLoader}
                  alt={infographic.desktop.alt}
                  src={`https:${infographic.desktop.src}`}
                  height={infographic.desktop.height}
                  width={infographic.desktop.width}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExplainerBlock;
